import {defineStore} from 'pinia'

export const useUserDataStore = defineStore('userData', {
  state: () => ({
    user: {
        account:'',
        name:'',
        label:'',
        level: null,
        parentUid: null,
        uid: ''
    },
  }),
  actions: {
    setUser(user) {
      this.user = user
    },
  },
  getters: {
      getUserData: (state) => state.user,
  }
})